import { render, staticRenderFns } from "./edit-teacher.vue?vue&type=template&id=71cdf318&scoped=true&"
import script from "./edit-teacher.vue?vue&type=script&lang=js&"
export * from "./edit-teacher.vue?vue&type=script&lang=js&"
import style0 from "./edit-teacher.vue?vue&type=style&index=0&id=71cdf318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdf318",
  null
  
)

export default component.exports